import { useTranslation } from '@/contexts/i18n-context';
import { SvgProps } from './email';
import clsx from 'clsx';
import styles from './styles.module.css';

export function BrokenLinkSvg({ className, ariaLabel }: SvgProps) {
  const { t } = useTranslation();
  return (
    <svg
      role="img"
      aria-label={ariaLabel ?? t('svg.brokenLink')}
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="80"
      viewBox="0 0 80 80"
      className={clsx(styles.brand, className)}
    >
      <path
        d="M51.9034 74.2305L46.8741 75L44.8204 61.5879L49.8497 60.8184L51.9034 74.2305Z"
        fill="inherit"
      />
      <path
        d="M69.3858 68.919L65.4141 72.1016L52.6875 56.2178L56.6583 53.0362L69.3858 68.919Z"
        fill="inherit"
      />
      <path
        d="M29.6036 31.2618L17.0899 36.5059C14.483 37.5984 12.6491 39.4399 11.5889 42.0293C10.5288 44.6191 10.5443 47.2182 11.6368 49.8252C12.7293 52.4321 14.5707 54.266 17.1602 55.3262C19.7499 56.3863 22.3491 56.3699 24.9561 55.2774L37.4708 50.0333L40.0928 56.2901L27.5782 61.5342C23.2505 63.3478 18.9223 63.3686 14.5938 61.5967C10.2653 59.8247 7.19357 56.775 5.37993 52.4473C3.56636 48.1195 3.54542 43.7905 5.31743 39.462C7.0895 35.1336 10.1402 32.0627 14.4678 30.2491L26.9815 25.0049L29.6036 31.2618Z"
        fill="inherit"
      />
      <path
        d="M76.254 51.46L74.4063 56.2012L61.7637 51.2735L63.6114 46.5323L76.254 51.46Z"
        fill="inherit"
      />
      <path
        d="M52.3292 27.8877L41.1788 39.7452L26.4483 46.25L22.5225 40.7178L37.253 34.212L48.4034 22.3545L52.3292 27.8877Z"
        fill="inherit"
      />
      <path
        d="M49.8536 5.14653C54.4945 4.56527 58.6684 5.71397 62.3731 8.5938C66.0778 11.4737 68.2204 15.2351 68.8018 19.876C69.3831 24.5169 68.2334 28.6899 65.3536 32.3946L57.0264 43.1075L51.67 38.9434L59.9981 28.2305C61.7327 25.9989 62.426 23.4943 62.0782 20.7178C61.7303 17.9413 60.4407 15.6851 58.209 13.9502C55.9774 12.2155 53.4728 11.5225 50.6963 11.8702C47.9198 12.218 45.6636 13.5077 43.9288 15.7393L35.6006 26.4522L30.2452 22.2881L38.5723 11.5752C41.4521 7.87085 45.2129 5.72796 49.8536 5.14653Z"
        fill="inherit"
      />
    </svg>
  );
}
